import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { CoupleNames } from '../components/CoupleNames';
import { Grain, Thoranam } from '../components/Thoranam';
import { authMessage } from '../lib/authErrors';

export function LoginPage() {
  const auth = useAuth();
  const [busy, setBusy] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);

  if (auth.status === 'ready') return <Navigate to="/" replace />;
  if (auth.status === 'denied') return <Navigate to="/access-denied" replace />;

  async function run() {
    setBusy(true);
    setLocalError(null);
    try {
      await auth.signInGoogle();
    } catch (err) {
      setLocalError(authMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="shell">
      <div className="bg bg-login" />
      <Thoranam />
      <Grain />
      <main className="invite-wrap">
        <section className="invite" aria-labelledby="invite-title">
          <span className="coin c1" aria-hidden="true" />
          <span className="coin c2" aria-hidden="true" />
          <span className="coin c3" aria-hidden="true" />
          <span className="coin c4" aria-hidden="true" />
          <img
            className="invite-ganesha"
            src="/theme/ganesha-diya.jpg"
            alt="Ganesha with a brass diya"
          />
          <p className="kicker">You are invited</p>
          <p className="ceremony">Shastiapthapoorthi</p>
          <CoupleNames id="invite-title" />
          <p className="sub">Sixty years, renewed in the manner of a wedding</p>
          <p className="date-chip">10 August 2026</p>
          <hr className="gold-rule" />

          {!auth.configured ? (
            <p className="msg">Firebase is not configured. Add the VITE_FIREBASE_* keys to .env.</p>
          ) : auth.status === 'loading' ? (
            <p className="fine">Lighting the lamps…</p>
          ) : (
            <>
              <div className="btn-row">
                <button className="btn gold" type="button" disabled={busy} onClick={() => void run()}>
                  Continue with Google
                </button>
              </div>
              <p className="fine">Sign in with a listed Google account.</p>
            </>
          )}
          {localError || auth.error ? <p className="msg">{localError || auth.error}</p> : null}
          <p className="fine">Family and friends only. The album is kept behind the invitation list.</p>
        </section>
      </main>
    </div>
  );
}
